import { ModalSize } from 'app/components/constants';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { toastFactory } from 'app/infrastructure/notifications/toast-factory';
import * as React from 'react';
import { ReactNode, useState, useCallback } from 'react';
import { FileSelector } from 'ui/file-selector';

interface UploadDocumentProps {
  onClose: () => void;
  onSubmit: (file: File) => void;
  acceptFileType?: string;
  className?: string;
  maxSizeMB?: number;
  textCancel: string;
  textSubmit: string;
  textChooseFile: string;
  textTitle: string;
  textFileTooLargeError: string;
  children?: ReactNode;
}

export const UploadDocument = ({
  onClose,
  onSubmit,
  acceptFileType: acceptFileTypes = '',
  className,
  children,
  maxSizeMB = 100,
  textSubmit,
  textCancel,
  textChooseFile,
  textTitle,
  textFileTooLargeError
}: UploadDocumentProps) => {

  const [file, setFile] = useState(undefined as File);

  const onDone = useCallback(() => {
    if (file) {
      onSubmit(file);
      handleSelect(undefined);
    }
  }, [file, onSubmit]);

  const handleSelect = useCallback((selectedFile: File) => {
    setFile(selectedFile);
  }, [setFile]);

  const onError = useCallback(() => {
    const toasts = toastFactory();
    toasts.dispatchError(textFileTooLargeError);
  }, [textFileTooLargeError]);

  return <ModalWrapper
    headerTitle={textTitle}
    btnTitle={textSubmit}
    btnCancelTitle={textCancel}
    isDisabled={!file}
    closeOnDone={false}
    onClose={onClose}
    onDone={onDone}
    size={ModalSize.large}>
    <div className={`input-wrapper ${className}`}>
      <FileSelector
        textSelectFile={textChooseFile}
        onSelected={handleSelect}
        disabled={false}
        acceptFileTypes={acceptFileTypes}
        maxSizeMB={maxSizeMB}
        textFileSizeError={textFileTooLargeError}
        onError={onError} />
      {children}
    </div>
  </ModalWrapper>;
};
